export class HTMLImageConfig {
    public static pathToImages = {
        Button_Close_url: 'assets/img/Button_Close.png',
        LD_user_url: 'assets/img/LD_user.svg',
        LD_btn_discount_url: 'assets/img/LD_btn_discount.svg',
        Sound_Icon_url: 'assets/img/Sound_Icon.png',
        Discount_Icon_url: 'assets/img/Discount_Icon.png',
        Logo_url: 'assets/img/Logo.png',
        arrow_url: 'assets/img/arrow.png',
        LipStick_3_url: 'assets/img/LipStick_3.png',
        Exit_icon_url: 'assets/img/Exit_icon.png',
        Warning_url: 'assets/img/Warning.png',
        tutorial_substate_url: 'assets/img/tutorial_substate.png',
        Button_back_url: 'assets/img/Button_back.png',
    }
}